<template>
    <div style="display:none"></div>
</template>

<script>
    export default {
        name: "Logout",
        mounted() {
            localStorage.removeItem("authKey");
            this.$root.userInfo = {};
            this.$router.replace("login");
        }
    }
</script>

<style scoped>

</style>